import Http from "../../services/Http";
import { GetActiveNotificationsResponse, NotificationReportCommand } from "api";
import { formatDateAsString } from "utils/helpers";

export class NotificationService {
  getActiveNotifications =
    async (): Promise<GetActiveNotificationsResponse> => {
      var response = await Http.get<GetActiveNotificationsResponse>({
        url: "Notifications/GetActiveNotifications",
        waitMessage: "Fetching Data...",
      });

      return response;
    };

  loadNotificationsReport = (requestData: NotificationReportCommand) => {
    var urlParams = `?startDate=${encodeURIComponent(
      formatDateAsString(requestData.startDate)
    )}&endDate=${encodeURIComponent(
      formatDateAsString(requestData.endDate)
    )}&includeResolved=${requestData.includeResolved}`;
    Http.openNewTab(`Notifications/LoadNotificationsReport${urlParams}`);
  };
}

export default new NotificationService();
